import React, { FC, ReactNode } from 'react';

interface IComponentProps {
  children: ReactNode;
}

export const Descriptions: FC<IComponentProps> = ({ children }) => {
  return <div className="descriptions">{children}</div>;
};
